/* eslint-disable react/no-unknown-property */
import {
  Card,
  CardSkeleton,
  ICON_ALERT_CIRCLE_OUTLINE,
  ICON_BULLSEYE_ARROW,
  Message,
} from '@doveit/bricks';
import React from 'react';
import { Agent } from '../../../providers/api/dtos';
import { ManagerGoalSimulationView } from '../manager-goal-simulation-view/ManagerGoalSimulationView';
import useManagerGoal from '../../hooks/use-manager-goal/useManagerGoal';
import { ManagerGoalMetricsView } from '../manager-goal-metrics-view/ManagerGoalMetricsView';
import EditManagerGoalAction from '../edit-manager-goal-action/EditManagerGoalAction';

export interface ManagerGoalWidgetProps {
  agentId: NonNullable<Agent['id']>,
}

export const LOAD_GOAL_ERROR_MESSAGE = 'Non è stato possibile caricare le informazioni degli obiettivi.';

export const ManagerGoalWidget: React.FC<ManagerGoalWidgetProps> = ({
  agentId,
}) => {
  const {
    data: existingGoal,
    isLoading: isExistingGoalLoading,
    error: existingGoalError,
    mutate: mutateExistingGoal,
  } = useManagerGoal(agentId);

  const onGoalAccepted = React.useCallback(() => {
    mutateExistingGoal();
  }, [mutateExistingGoal]);

  if (isExistingGoalLoading) {
    return <CardSkeleton aria-label="Obiettivi personali manager in caricamento" />;
  }

  if (existingGoalError && existingGoalError.status !== 404) {
    return (
      <Card>
        <Card.Header
          icon={{ path: ICON_ALERT_CIRCLE_OUTLINE }}
          title="Obiettivi personali manager"
          color="critical"
        />
        <Card.Content>
          <Message message={LOAD_GOAL_ERROR_MESSAGE} />
        </Card.Content>
      </Card>
    );
  }

  return (
    <Card aria-label="Obiettivi personali manager">
      <Card.Header
        title="Obiettivi personali manager"
        icon={{ path: ICON_BULLSEYE_ARROW }}
        primaryActions={existingGoal ? [
          <EditManagerGoalAction
            agentId={agentId}
            label="Modifica"
          />,
        ] : []}
      />
      <Card.Content>
        {existingGoal
          ? <ManagerGoalMetricsView goal={existingGoal} />
          : (
            <ManagerGoalSimulationView
              agentId={agentId}
              onGoalAccepted={onGoalAccepted}
            />
          )}
      </Card.Content>
    </Card>
  );
};

export default ManagerGoalWidget;
